import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EventService } from '../../services/event.service';
import { Event } from '../../models/event.model';
import { DatePipe, NgStyle } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { IncrementDirective } from '../../directives/increment.directive';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-event-widget',
  standalone: true,
  imports: [TranslateModule, DatePipe, NgStyle, IncrementDirective],
  templateUrl: './event-widget.component.html',
  styleUrl: './event-widget.component.scss',
})

export class EventWidgetComponent {
  @Input() event: Event | null = null;
  loading:boolean = true;
  error:number | null = null;
  lang:string = 'en-EN';
  timezone:string = '';
  constructor(
    private eventService: EventService,
    private route: ActivatedRoute,
    private languageService: LanguageService
  ) {}

  ngOnInit(): void {
    this.timezone = new Date().getTimezoneOffset().toString();    
    this.lang = this.languageService.getLanguage();    
    const eventId: string | null = this.route.snapshot.paramMap.get('eventId');

    if (!eventId) {
      console.error(`Erreur avec l'id d'event : ${eventId}.`);
      return;
    }

    this.eventService.getEvent(eventId).subscribe({
      next: (event:Event) => {
        this.event = event;
      },
      error: (err:HttpErrorResponse) => {
            this.loading = false;
            this.error = err.status;            
          },
      complete: () => {
        this.loading = false;
      },
    });
  }
}
